<div class="login-content">
  <img
    class="close-icon"
    src="./../../../../assets/icons/x.svg"
    alt=""
    (click)="onNoClick()"
  />

  <div class="login-content-logo">
    <img src="../../../../assets/logo/Logo.svg" alt="" />
  </div>
  <p class="title">Email Verified!</p>

  <p class="paragraph2">Thanks for verifying your email. Login to continue your experience.</p>

  <button class="primary-btn" type="submit" (click)="onNoClick()">OK!</button>
</div>
